import type { ParsedUrlQueryInput } from "querystring";

import type { PlusDetailedListingState, PlusDetailedListingType } from "./types";

export const QueryParameterName = "plus-detail";
const QuerySeparator = ":";
type EntityUuid = string;
type PlusDetailedListingQuery =
  | `${PlusDetailedListingType}`
  | `${PlusDetailedListingType}${typeof QuerySeparator}${EntityUuid}`;

export function decodePlusDetailedListingQuery(
  searchParameters: Readonly<URLSearchParams>,
): PlusDetailedListingState | null {
  const query = searchParameters.get(QueryParameterName) as PlusDetailedListingQuery;
  const [detailType, detailItemEntityUuid] = query?.split(QuerySeparator) ?? [];

  switch (detailType) {
    case "fact-sheet":
    case "daily-pulse":
    case "quick-digest":
      return { type: detailType };
    case "author":
    case "topic":
      if (!detailItemEntityUuid) return null;

      return { entityUuid: detailItemEntityUuid, type: detailType };
    default:
      return null;
  }
}

export function encodePlusDetailedListingQuery(
  plusDetailedListingState: PlusDetailedListingState,
): { [QueryParameterName]: PlusDetailedListingQuery } {
  switch (plusDetailedListingState.type) {
    case "fact-sheet":
    case "daily-pulse":
    case "quick-digest":
      return { [QueryParameterName]: plusDetailedListingState.type };
    case "author":
    case "topic":
      return {
        [QueryParameterName]: `${plusDetailedListingState.type}${QuerySeparator}${plusDetailedListingState.entityUuid}`,
      };
  }
}

export function removedPlusDetailedListingQuery(input: ParsedUrlQueryInput) {
  const { [QueryParameterName]: _, ...rest } = input;
  return rest;
}
